import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AppShell from "@/components/layout/AppShell";
import DashboardPage from "@/pages/DashboardPage";
import WorkspacePage from "@/pages/WorkspacePage";
import BoardPage from "@/pages/BoardPage";
import TeamPage from "@/pages/TeamPage";
import ReportsPage from "@/pages/ReportsPage";
import NotificationsPage from "@/pages/NotificationsPage";
import SettingsPage from "@/pages/SettingsPage";
import AdminPage from "@/pages/AdminPage";
import CalendarPage from "@/pages/CalendarPage";
import ChatPage from "@/pages/ChatPage";
import AdminTasksPage from "@/pages/AdminTasksPage";
import AssistancePage from "@/pages/AssistancePage";
import HowToPage from "@/pages/HowToPage";

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) return (
        <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] dark:bg-[#0B0D10]">
            <div className="flex flex-col items-center gap-3">
                <div className="w-8 h-8 border-2 border-[#002FA7] dark:border-[#6A91FF] border-t-transparent rounded-full animate-spin"></div>
                <p className="text-sm text-gray-500 dark:text-gray-400 font-['IBM_Plex_Sans']">Se încarcă...</p>
            </div>
        </div>
    );
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <ErrorBoundary>
                <ThemeProvider>
                    <BrowserRouter>
                        <AuthProvider>
                            <Routes>
                                <Route path="/login" element={<LoginPage />} />
                                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                                <Route path="/reset-password" element={<ResetPasswordPage />} />
                                <Route path="/" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
                                    <Route index element={<DashboardPage />} />
                                    <Route path="workspaces/:id" element={<WorkspacePage />} />
                                    <Route path="boards/:id" element={<BoardPage />} />
                                    <Route path="teams/:id" element={<TeamPage />} />
                                    <Route path="reports" element={<ReportsPage />} />
                                    <Route path="notifications" element={<NotificationsPage />} />
                                    <Route path="settings" element={<SettingsPage />} />
                                    <Route path="admin" element={<AdminPage />} />
                                    <Route path="admin/tasks" element={<AdminTasksPage />} />
                                    <Route path="calendar" element={<CalendarPage />} />
                                    <Route path="chat" element={<ChatPage />} />
                                    <Route path="chat/:channelId" element={<ChatPage />} />
                                    <Route path="assistance" element={<AssistancePage />} />
                                    <Route path="ghid" element={<HowToPage />} />
                                </Route>
                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                            <Toaster richColors position="top-right" theme="light" />
                        </AuthProvider>
                    </BrowserRouter>
                </ThemeProvider>
            </ErrorBoundary>
        </div>
    );
}

export default App;
